import LayoutBasic from "@/views/layouts/LayoutBasic";
import DivisionSettings from "@/views/divisions/Settings";
import Salary from "@/views/divisions/Salary.vue";


const routes = {
  path: '/divisions',
  component: LayoutBasic, // Change the desired Layout here,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'settings',
      component: DivisionSettings,
      name: 'divisionsSettings',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'divisions/settings'
      }
    },
    {
      path: 'salary',
      component: Salary,
      name: 'divisionsSalaryHistory',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'divisions/salary'
      }
    },
  ]
}

export default routes;
